var $03a1900e7400b5ab$exports = {};
$03a1900e7400b5ab$exports = {
  "buttonLabel": "R\u0101d\u012Bt ieteikumus",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "Pieejamo opciju skaits: ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opcija");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opcijas");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Ievad\u012Bta grupa ".concat(args.groupTitle, ", ar ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opciju");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opcij\u0101m");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", atlas\u012Bta",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Ieteikumi",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", atlas\u012Bta");
  }
};
export { $03a1900e7400b5ab$exports as default };